<div class="wrapper">
  <app-header></app-header>
  <div class="main">
      <div class="container-fluid container-fluid-5">
          <div class="row row5">
              <div class="sidebar col-md-2 hide-small">
                  <app-sidebar></app-sidebar>
              </div>
              <div class="col-12 hide-large featured-box">
              </div>
              <div class="col-md-10 report-main-content m-t-5">
                <div class="card">
                  <div class="card-header"><h4 class="mb-0">Bet History</h4></div>
                  <div class="card-body container-fluid container-fluid-5">
                    <div class="row row5">
                        <div class="col-sm-2 col-md-2 col-6">
                          <div class="form-group mb-0">
                            <select name="betType" class="form-select" placeholder="Select Bet Type" [(ngModel)]="betType"
                                [ngModelOptions]="{standalone: true}" aria-label="Default select example" (ngModelChange)="selectMatchType()">
                                <option class="select-option" value="settled">Matched</option>
                              <option class="select-option"  value="">Deleted</option>
                            </select>
                          </div>
                        </div>
                        <div class="col-sm-2 col-md-2 col-6">
                          <div class="form-group mb-0">
                            <ng-select class="form-control" [ngModelOptions]="{standalone: true}" [(ngModel)]="searchSport"   class="form-select"
                                (change)="getFilterData(searchSport.sport_id)">
                                <!-- <ng-option value="" selected>All</ng-option> -->
                                <ng-option *ngFor="let sport of SportList" [value]="sport">{{sport.sport_name}}</ng-option>
                            </ng-select>
                          </div>
                        </div>
                        <div class="col-sm-2 col-md-2 col-6 btn-col">
                          <div class="mx-input-wrapper">
                            <input type="text" class="mx-input" [popover]="popTemplateStatementStart"
                                placement="bottom" [outsideClick]="true" #popoverRef="bs-popover"
                                value="{{statementStartDate | date:'yyyy-MM-dd'}}" (click)="showDate()">
                            <span class="mx-input-append"><i class="fa fa-calendar-o"></i></span>
                          </div>
                        </div>
                        <div class="col-sm-2 col-md-2 col-6 btn-col">
                          <div class="mx-input-wrapper">
                            <input type="text" class="mx-input" [popover]="popTemplateStatementEnd"
                            placement="bottom" [outsideClick]="true" #popoverRef="bs-popover"
                            value="{{statementEndDate | date:'yyyy-MM-dd'}}" (click)="showDate()">
                            <span class="mx-input-append"><i class="fa fa-calendar-o"></i></span>
                          </div>
                        </div>
                        <div class="col-sm-1 col-md-1 col-12 btn-col">
                          <button class="btn btn-primary btn-block mobile-width" (click)="settledBets('filterBtnClick')">Submit</button>
                        </div>
                    </div>
                    <div class="row row5 mt-2 hide-small">
                        <div class="col-12 account-statement-tbl">
                          <div class="table-responsive">
                            <table class="table b-table table-striped table-bordered">
                              <thead>
                                <tr class="text-center">
                                    <th class="text-center">Event Name</th>
                                    <th class="text-center">Nation</th>
                                    <th class="text-center">Bet Type</th>
                                    <th class="text-center">User Rate</th>
                                    <th class="text-right">Amount</th>
                                    <th class="text-right">Profit/loss</th>
                                    <th class="text-right">Result</th>
                                    <th class="text-center">Place Date</th>
                                    <th class="text-center">Match Date</th>
                                </tr>
                              </thead>
                              <tbody *ngIf="settledBetData?.length != 0">
                                <ng-container *ngFor="let data of settledBetData;let i = index;" style="text-align: center;">
                                <tr  [ngClass]="{'back':data?.is_back == 1,'lay':data?.is_back == 0}">
                                    <td class="text-center">{{data?.is_fancy == 0 ? data?.match_name :  data?.market_name}}</td>
                                    <td class="text-center">{{data?.is_fancy == 0 ? data?.selection_name : (data?.market_name)}} <span *ngIf="data?.is_fancy == 1">/ {{data?.size}}</span></td>
                                    <td class="text-center" *ngIf="data?.is_fancy == 0">{{ data?.is_back == 1 ? 'Back' : 'Lay'}}</td>
                                    <td class="text-center" *ngIf="data?.is_fancy == 1">{{ data?.is_back == 1 ? 'Yes' : 'No'}}</td>
                                    <td class="text-right"> {{data?.updateOdds}}</td>
                                    <td class="text-right">{{data?.stack}}</td>
                                    <td class="text-right" [ngClass]="{'red':data?.updatePl < 0,'green':data?.updatePl >= 0}">{{data?.updatePl}}</td>
                                    <td class="text-right">{{data?.winner_name}}</td>
                                    <td class="text-center">{{data?.createdAt| date :'dd-MM-yyyy hh:mm:ss aa'}}</td>
                                    <td class="text-center">{{data?.createdAt| date :'dd-MM-yyyy hh:mm:ss aa'}}</td>
                                </tr>
                              </ng-container>
                              </tbody>
                              <tbody *ngIf="settledBetData?.length == 0">
                                <tr>
                                  <td class="no-data-available" colspan="9">No data!</td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        </div>
                    </div>
                    <div class="row row5 mt-2 hide-large" *ngIf="settledBetData?.length != 0">
                        <div class="col-12">
                          <ng-container *ngFor="let data of settledBetData;let i = index;" style="text-align: center;">
                            <div class="bet-history" [ngClass]="{'back':data?.is_back == 1,'lay':data?.is_back == 0}">
                              <div class="row row5">
                                <div class="col-6">
                                  <div>
                                    <a><b>{{data?.is_fancy == 0 ? data?.match_name :  data?.market_name}}</b></a>
                                  </div>
                                  <div>
                                    <strong>Nation: </strong>
                                    {{data?.is_fancy == 0 ? data?.selection_name : (data?.market_name)}} <span *ngIf="data?.is_fancy == 1">/ {{data?.size}}</span>
                                  </div>
                                  <div>
                                    <strong>Place Date: </strong>
                                    {{data?.createdAt| date :'dd-MM-yyyy hh:mm:ss aa'}}
                                  </div>
                                  <div>
                                    <strong>Match Date:</strong>
                                    {{data?.createdAt| date :'dd-MM-yyyy hh:mm:ss aa'}}
                                  </div>
                                </div>
                                <div class="col-2 text-right">
                                  <div><b>User Rate</b></div>
                                  <div>{{data?.updateOdds}}</div>
                                </div>
                                <div class="col-2 text-right">
                                  <div><b>Amount</b></div>
                                  <div>{{data?.stack | number : '0.0-2'}}</div>
                                </div>
                                <div class="col-2 text-right">
                                  <div><b>P&L</b></div>
                                  <div [ngClass]="{'red':data?.updatePl < 0,'green':data?.updatePl >= 0}">{{data?.updatePl | number : '0.0-2'}}</div>
                                </div>
                              </div>
                            </div>
                          </ng-container>
                        </div>
                    </div>
                    
                    <div class="row row5 mt-2 hide-large" *ngIf="settledBetData?.length == 0">
                      <div class="col-12">
                          <p class="mb-0 text-center">
                            There are no records to show
                          </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
          </div>
      </div>
  </div>
</div>

<app-footer-main></app-footer-main>


<!-- Date Time Picker -->
<ng-template #popTemplateStatementStart>
  <datepicker [hidden]="!isDateVisible" [(ngModel)]="dateStatement" [ngModelOptions]="{standalone: true}" [minDate]="minDate"  [maxDate] ="todayDateTime"[showWeeks]="false"
      (ngModelChange)="updateDateStatement()" (selectionDone)="dateSelectionDone()">
  </datepicker>
  <timepicker [hidden]="!isDateVisible" [(ngModel)]="timeStatement" [ngModelOptions]="{standalone: true}" [min]="minTime" [max]="maxTime" (ngModelChange)="updateTimeStatement()" [showMeridian]="isMeridian" showSeconds="true">
  </timepicker>

  <div style="padding:5px">
      <span class="btn-group pull-left" style="margin-right:10px;">
          <button type=button class="btn btn-sm btn-info" [hidden]="!isDateVisible" (click)="today()">Today</button>
          <button type=button class="btn btn-sm btn-danger" (click)="clear()">Clear</button>
      </span>
      <span class="btn-group pull-right">
          <button type=button class="btn btn-sm btn-success" (click)="close()">Close</button>
      </span> <span class=clearfix></span>
  </div>
</ng-template>
<ng-template #popTemplateStatementEnd>
  <datepicker [hidden]="!isDateVisible" [(ngModel)]="endDateStatement" [ngModelOptions]="{standalone: true}" [minDate]="dateStatement" [maxDate] ="todayDateTime" [showWeeks]="false"
      (ngModelChange)="updateEndDateStatement()" (selectionDone)="dateSelectionDone()">
  </datepicker>
  <timepicker [hidden]="!isDateVisible" [(ngModel)]="endTimeStatement" [ngModelOptions]="{standalone: true}" [min]="minTime" [max]="maxTime"  (ngModelChange)="updateEndTimeStatement()"
      [showMeridian]="isMeridian" showSeconds="true">
  </timepicker>

  <div style="padding:5px">
      <span class="btn-group pull-left" style="margin-right:10px;">
          <button type=button class="btn btn-sm btn-info" [hidden]="!isDateVisible" (click)="today()">Today</button>
          <button type=button class="btn btn-sm btn-danger" (click)="clear()">Clear</button>
      </span>
      <span class="btn-group pull-right">
          <button type=button class="btn btn-sm btn-success" (click)="closeEndDatepicker()">Close</button>
      </span> <span class=clearfix></span>
  </div>
</ng-template>

